/**
 * Labels de qualificação sensíveis ao gênero.
 * Uso: getQualificationLabel("socio", "feminino") → "Sócia"
 */

export type Sexo = "masculino" | "feminino";

const labels: Record<string, Record<Sexo, string>> = {
  socio_gestor: { masculino: "Sócio Gestor", feminino: "Sócia Gestora" },
  socio: { masculino: "Sócio", feminino: "Sócia" },
  associado: { masculino: "Associado", feminino: "Associada" },
  estagiario: { masculino: "Estagiário", feminino: "Estagiária" },
  colaborador: { masculino: "Colaborador", feminino: "Colaboradora" },
  controller: { masculino: "Controller", feminino: "Controller" },
  institution_external: { masculino: "Acesso Externo", feminino: "Acesso Externo" },
};

/** Plural genérico para filtros (não varia por gênero individual) */
export const qualificationPluralLabel: Record<string, string> = {
  socio_gestor: "Sócios Gestores",
  socio: "Sócios",
  associado: "Associados",
  estagiario: "Estagiários",
  colaborador: "Colaboradores",
  controller: "Controllers",
  institution_external: "Acesso Externo",
};

export function getQualificationLabel(
  qualificacao: string,
  sexo?: string | null,
): string {
  const entry = labels[qualificacao];
  if (!entry) return qualificacao;
  const s: Sexo = sexo === "feminino" ? "feminino" : "masculino";
  return entry[s];
}
